import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import "./style.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { NavLink, useLocation, useParams } from "react-router-dom";
//import Trending from '../../components/TrendingNow/Trending';
import PresentationCard from "components/PresentationCard/PresentationCard";
import axios from "axios";
import Form from "react-bootstrap/Form";
import TabContainer from "react-bootstrap/TabContainer";
import Button from "components/Button/Button";
import { HeaderConfig } from "Api/Api";
import { user_Status, search_Presentation_API } from "Api/Api";
import FullPageSpinner from "components/FullPageSpinner/FullPageSpinner";
import {
  org_friendly_url,
  user_API,
  User_Patch_Api,
  myHeaders_Autorized,
  Category_list_Api,
  user_entity_uuid,
  myHeaders_Auth_With_Cache_Control,
} from "Api/Api";
import { current_unix_stamp } from "utils/Helper";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import Footer from "../../components/Footer/Footer";
import FavouriteModal from "components/FavoriteModal/FavoriteModal";
import Modal from "react-bootstrap/Modal";
import { local_routes } from "utils/Routes";
import home from "Assets/home.svg";

const MAX_ITEMS = 15;
// class categoryDetail extends Component {
const CategoryDetail = (props) => {
  const location = useLocation();
  const params = useParams();

  const [categories, set_categories] = useState([]);
  const [is_loading, set_is_loading] = useState(true);
  const [is_loading_drop, set_is_loading_drop] = useState(true);
  const [show, set_show] = useState(false);
  const [category_presentation_arr, set_category_presentation_arr] = useState([]);
  const [category_detail_arr, set_category_detail_arr] = useState([]);
  const [is_open, set_is_open] = useState(true);
  const [filtered_total_cat_items, set_filtered_total_cat_items] = useState([]);
  const [filtered_total_fav_items, set_filtered_total_fav_items] = useState([]);
  const [category_sort, set_category_sort] = useState("view_count");
  const [modal_loader, set_modal_loader] = useState(false);
  const [favourite_cat, set_favourite_cat] = useState(false);
  const [curr_data, set_curr_data] = useState({});
  const [entity_info, set_entity_info] = useState(null);
  const [is_no_more, set_is_no_more] = useState(false);
  const [category_img, set_category_img] = useState(null);
  const [category_loader, set_category_loader] = useState(false);

  let workspace_base_url = "";
  if (org_friendly_url) {
    workspace_base_url = local_routes.workspace + "/" + org_friendly_url;
  }
  useEffect(() => {
    routeChanged();
  }, [location.pathname]);

  const routeChanged = () => {
    window.scrollTo(0, 0);
    MainAPICall();
  };

  const MainAPICall = () => {
    axios
      .get(`${Category_list_Api}/${params.friendly_url}`, HeaderConfig)
      .then((response) => {
        set_entity_info(response.data);
        APICallPromises(response.data);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    MainAPICall();
  }, []);

  // Method to call Category_list_Api,search_Presentation_API,
  const APICallPromises = async (curr_data, force_cat_sort) => {
    set_is_no_more(false);
    let cat_Sort;
    // Section to do validation of sort by
    if (force_cat_sort) {
      cat_Sort = force_cat_sort;
    } else {
      cat_Sort = category_sort;
    }

    try {
      // API Calls using Promise method
      let initial_promises = [];
      initial_promises.push(axios.get(`${Category_list_Api}`, HeaderConfig));
      let params = {
        //presentation_format: '20x20',
        get_presenter: true,
        categories_uuid: curr_data.entity_uuid,
        categories_text: curr_data.entity_name,
        sort_by: cat_Sort,
        sort_order: "DESC",
        limit: 30,
      };

      //initial_promises.push(axios.get(`${search_Presentation_API}?presentation_format=20x20&get_presenter=true&categories_uuid=${curr_data.entity_uuid}&categories_text=${encodeURIComponent(curr_data.entity_name)}&sort_by=${cat_Sort}&sort_order=DESC&limit=30`, HeaderConfig));
      initial_promises.push(
        axios.get(`${search_Presentation_API}`, { params, ...HeaderConfig })
      );

      if (user_Status === 1) {
        initial_promises.push(
          axios.get(
            `${user_API}/${user_entity_uuid}/categories.audience`,
            myHeaders_Autorized
          )
        );
      }
      let [allCategoriesListRes, searchPresentationRes, favCategoriesRes] =
        await Promise.all(initial_promises);

      let categories = allCategoriesListRes.data.entities;
      // JBB - it feels strange to remove the current category from the list, especially when it is one of the favorites. So leave it in for now.
      let favArr = []; // user favorites
      let catArr = []; // user non-favorites

      // make fav cat obj for easy retrieval later
      let tmp_fav_cat_obj = {};

      let tmp_favorite_cat = false;

      if (user_Status === 1 && favCategoriesRes) {
        for (let tmp_fav_cat of favCategoriesRes.data) {
          if (
            tmp_fav_cat.xref_data &&
            tmp_fav_cat.xref_data.favorited_time &&
            tmp_fav_cat.xref_data.favorited_time > 0
          ) {
            tmp_fav_cat_obj[tmp_fav_cat.entity_uuid] = tmp_fav_cat;
            if (tmp_fav_cat.entity_uuid === curr_data.entity_uuid) {
              tmp_favorite_cat = true;
            }
          }
        }
        // lets put fav cats at top of categories array
        let tmp_nonfav_categories = [];
        let tmp_fav_categories = []; // build this so we maintain alphabetical
        for (let i = 0; i < categories.length; i++) {
          let tmp_cat = categories[i];
          if (tmp_fav_cat_obj[tmp_cat.entity_uuid]) {
            tmp_fav_categories.push(tmp_cat);
          } else {
            tmp_nonfav_categories.push(tmp_cat);
          }
        }
        categories = tmp_fav_categories.concat(tmp_nonfav_categories);
      }

      // build right-hand cat list for logged-in users
      if (user_Status === 1) {
        for (let tmp_cat_obj of categories) {
          if (tmp_fav_cat_obj[tmp_cat_obj.entity_uuid]) {
            favArr.push(tmp_cat_obj);
          } else {
            catArr.push(tmp_cat_obj);
          }
        }
        set_filtered_total_fav_items(favArr);
        set_filtered_total_cat_items(catArr);
      } else {
        set_categories(categories); // right-hand cat list for non-logged-in users
      }

      if (curr_data.image_url !== undefined) {
        let url = curr_data.image_url;
        let array = url.split("/");
        set_category_img(
          `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padtransparent_noborder_640x480/${array[5]}`
        );
      }
      set_is_loading_drop(false);
      set_favourite_cat(tmp_favorite_cat);
      set_category_presentation_arr(
        searchPresentationRes.data.search_query_results
      );
      set_category_detail_arr(curr_data);
      set_is_loading(false);
    } catch (err) {}
  };

  // Show more/less Button toggle
  const toggle = () => {
    set_is_open(!is_open);
  };
  // This method is the logic for show more/less categories
  const getRenderedItems = () => {
    if (user_Status === 1) {
      if (is_open) {
        return filtered_total_cat_items;
      }
      return filtered_total_cat_items.slice(0, MAX_ITEMS);
    } else {
      if (is_open) {
        return categories;
      }
      return categories.slice(0, MAX_ITEMS);
    }
  };

  const handleChangeOtherCategorySort = (e) => {
    set_category_sort(e.target.value);
    set_is_loading_drop(true);
    if (user_Status === 1) {
      APICallPromises(entity_info, e.target.value);
    } else {
      APICallPromises(entity_info, e.target.value);
    }
    set_category_sort(e.target.value);
  };

  // Method for adding Favourites
  const addFavourites = (item) => {
    set_modal_loader(true);
    let catTempArr = [
      {
        xref_data: {
          favorited_time: current_unix_stamp,
        },
        entity_uuid: item.entity_uuid,
      },
    ];
    let categories_Selected = { "categories.audience": catTempArr };
    axios
      .patch(
        `${User_Patch_Api}/${user_entity_uuid}`,
        JSON.stringify(categories_Selected),
        myHeaders_Autorized
      )
      .then(() => {
        if (user_Status === 1) {
          set_modal_loader(false);
          set_favourite_cat(true);
          // Here calling GET Fav Categories for Cache-Control: max-age=0 starts
          axios.get(
            `${user_API}/${user_entity_uuid}/categories.audience`,
            myHeaders_Auth_With_Cache_Control
          );
          // Here Calling GET Fav Categories end
        } else {
          set_modal_loader(false);
        }
      })
      .catch(() => {
        set_modal_loader(false);
      });
  };

  const loadMoreEvents = () => {
    return (
      <React.Fragment>
        {is_no_more ? (
          <h4>No more presentations to show</h4>
        ) : category_loader === false ? (
          <p style={{ textAlign: "center" }}>
            <span onClick={onLoadMoreClick} className="loadmore-btn">
              Load More...
            </span>
          </p>
        ) : (
          <ActivityIndicator theme="button-Status-Loader button-CategoryLoader" />
        )}
      </React.Fragment>
    );
  };

  const onLoadMoreClick = (e) => {
    e.preventDefault();
    const { entity_name } = entity_info || {};
    let cat_Sort = category_sort;
    // Section to do validation of sort by
    set_category_loader(true);
    const from = category_presentation_arr.length;
    let params = {
      //presentation_format: '20x20',
      get_presenter: true,
      categories_uuid: entity_info.entity_uuid,
      categories_text: entity_name,
      sort_by: cat_Sort,
      sort_order: "DESC",
      limit: 300,
      from,
    };
    //axios.get(`${search_Presentation_API}?presentation_format=20x20&get_presenter=true&categories_uuid=${this.state.entityInfo.entity_uuid}&categories_text=${entity_name}&sort_by=${cat_Sort}&sort_order=DESC&limit=30&from=${from}`, HeaderConfig)
    axios
      .get(`${search_Presentation_API}`, { params, ...HeaderConfig })
      .then((searchPresentationRes) => {
        if (
          searchPresentationRes.data &&
          searchPresentationRes.data.search_query_results &&
          searchPresentationRes.data.search_query_results.length
        ) {
          set_category_loader(false);
          set_category_presentation_arr((arr) => [
            ...arr,
            ...searchPresentationRes.data.search_query_results,
          ]);
        } else {
          set_is_no_more(true);
          set_category_loader(false);
        }
      })
      .catch((error) => {});
  };

  // Toogles modal show
  const showModal = () => {
    set_show(true);
  };
  // Toogles modal hide
  const hideModal = () => {
    set_show(false);
  };

  if (is_loading) {
    return (
      <React.Fragment>
        <FullPageSpinner />
      </React.Fragment>
    );
  }

  const selectedSort = category_sort;
  return (
    <React.Fragment>
      <div>
        <Helmet defer={false}>
          <title>{`PechaKucha ${category_detail_arr.entity_name} Video Presentations`}</title>
          <meta
            name="description"
            content={`PechaKucha ${category_detail_arr.entity_name} Presentations. All in 20x20 Pecha Kucha format.`}
          />
          <meta property="og:image" content={category_img} />
          <meta property="og:type" content="website" />
          <meta
            property="og:url"
            content={`https://www.pechakucha.com${local_routes.categories}/${category_detail_arr.friendly_url}`}
          />
          <meta
            property="og:title"
            content={`PechaKucha ${category_detail_arr.entity_name} Video Presentations`}
          />
          <meta
            property="og:description"
            content={`PechaKucha ${category_detail_arr.entity_name} Presentations. All in 20x20 Pecha Kucha format.`}
          />
        </Helmet>
        <div className="container CategoryPage">
          <div className="trending-categories">
            <Row className="mb-view">
              <Col lg={8} md={12} sm={12}>
                {!is_loading ? (
                  <div className="categories art-details">
                    <h3 className="trending-heading art-heading">
                      {category_detail_arr.entity_name}
                    </h3>
                    <div>
                      <Row>
                        <Col lg={6} md={6} sm={5}>
                          <div className="">
                            <img
                              src={category_img}
                              className="img-fluid rounded"
                              alt="category-img"
                            />
                          </div>
                        </Col>
                        <Col lg={6} md={6} sm={7}>
                          <div className="mb-data">
                            <div
                              className="category-title"
                              dangerouslySetInnerHTML={{
                                __html: category_detail_arr["description"],
                              }}
                            />
                            {user_Status === 1 ? (
                              <div>
                                {modal_loader === false ? (
                                  favourite_cat === true ? (
                                    <span className="favourite">
                                      Followed Category
                                    </span>
                                  ) : (
                                    <Button
                                      theme="btn-global btn-green btn-add"
                                      OnClickMet={
                                        favourite_cat === false
                                          ? () =>
                                              addFavourites(category_detail_arr)
                                          : null
                                      }
                                    >
                                      Add to Followed Categories
                                    </Button>
                                  )
                                ) : (
                                  <div className="category-spinner-section">
                                    <ActivityIndicator theme="button-Status-Loader" />
                                  </div>
                                )}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div>
                      <div className="favorites all-categories">
                        <h3 className="trending-heading">
                          {category_detail_arr.entity_name}
                        </h3>
                        <Form>
                          <Form.Group>
                            <div className="form-dropdownlist">
                              <Form.Control
                                as="select"
                                required
                                onChange={handleChangeOtherCategorySort}
                                defaultValue={selectedSort}
                              >
                                <option value="view_count">Trending PKs</option>
                                <option value="created_time">Recent PKs</option>
                              </Form.Control>
                            </div>
                          </Form.Group>
                        </Form>
                      </div>
                      <div>
                        {!is_loading_drop ? (
                          <div className="case-studies">
                            {/* PK Details1 */}
                            {category_presentation_arr.length > 0 ? (
                              <React.Fragment>
                                <Row>
                                  {category_presentation_arr.map((item) => (
                                    <Col
                                      key={item.entity_info.entity_uuid}
                                      lg={6}
                                      sm={12}
                                      md={6}
                                    >
                                      <PresentationCard
                                        key={item.entity_info.entity_uuid}
                                        presentation_info={item.entity_info}
                                      />
                                    </Col>
                                  ))}
                                </Row>
                                <Row>
                                  {category_presentation_arr.length > 29 && (
                                    <Col lg={12}>{loadMoreEvents()}</Col>
                                  )}
                                </Row>
                              </React.Fragment>
                            ) : (
                              <Row>
                                <Col
                                  lg={6}
                                  sm={12}
                                  md={6}
                                  className="flex-center"
                                >
                                  <p>No Presentations in this category</p>
                                </Col>
                              </Row>
                            )}
                          </div>
                        ) : (
                          <ActivityIndicator theme="spinner" />
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <ActivityIndicator theme="spinner" />
                )}
              </Col>
              <Col lg={4} md={12} sm={12}>
                <div className="categories-list">
                  {user_Status === 1 && filtered_total_fav_items.length > 0 ? (
                    <div className="favorite-category">
                      <h3 className="favorite-heading related-heading">
                        My Followed Categories
                      </h3>
                      {
                        <div>
                          {filtered_total_fav_items.map((data) => (
                            <NavLink
                              key={data.friendly_url}
                              to={{
                                pathname: `${workspace_base_url}${local_routes.categories}/${data.friendly_url}`,
                              }}
                            >
                              <div
                                key={data.entity_uuid}
                                className="categoryItem"
                              >
                                {data.entity_name}
                              </div>
                            </NavLink>
                          ))}
                        </div>
                      }

                      {/* Modal section */}
                      <div className="modal-content-custom">
                        <Modal
                          size="lg"
                          show={show}
                          onHide={hideModal}
                          className="modal-content-custom"
                        >
                          <div>
                            <FavouriteModal
                              totalFavItems={filtered_total_fav_items}
                            />
                          </div>
                          <div>
                            <Button theme="modal-button" OnClickMet={hideModal}>
                              x
                            </Button>
                          </div>
                        </Modal>
                        <Button
                          theme="btn-global btn-green btn-favorite"
                          OnClickMet={showModal}
                        >
                          Edit Followed Categories
                        </Button>
                      </div>
                    </div>
                  ) : null}
                  {user_Status === 1 ? (
                    <React.Fragment>
                      {filtered_total_cat_items.length !== 0 && (
                        <div className="favorite-category">
                          {/* all categories for no user section */}
                          <h3 className="favorite-heading">All Categories</h3>
                          <TabContainer
                            id="left-tabs-example"
                            defaultActiveKey="first"
                          >
                            <div>
                              {getRenderedItems().map((item, id) => (
                                <NavLink
                                  key={item.friendly_url}
                                  to={{
                                    //pathname: `/categorydetail/${item.friendly_url}`,
                                    pathname: `${workspace_base_url}${local_routes.categories}/${item.friendly_url}`,
                                  }}
                                >
                                  <div key={id} className="categoryItem">
                                    {item.entity_name}
                                  </div>
                                </NavLink>
                              ))}
                              {filtered_total_cat_items.length > 15 && (
                                <button
                                  onClick={toggle}
                                  className="btn-moreCategories"
                                >
                                  {is_open
                                    ? "View Less Categories"
                                    : "View More Categories"}
                                </button>
                              )}
                            </div>
                          </TabContainer>
                        </div>
                      )}
                    </React.Fragment>
                  ) : (
                    <div className="favorite-category">
                      <h3 className="favorite-heading">All Categories</h3>
                      <TabContainer
                        id="left-tabs-example"
                        defaultActiveKey="first"
                      >
                        <div>
                          {getRenderedItems().map((item, id) => (
                            <NavLink
                              key={item.entity_uuid}
                              to={{
                                //pathname: `/categorydetail/${item.friendly_url}`,
                                pathname: `${workspace_base_url}${local_routes.categories}/${item.friendly_url}`,
                              }}
                            >
                              <div key={id} className="categoryItem">
                                {item.entity_name}
                              </div>
                            </NavLink>
                          ))}
                          {categories.length > 15 && (
                            <button
                              onClick={toggle}
                              className="btn-moreCategories"
                            >
                              {is_open
                                ? "View Less Categories"
                                : "View More Categories"}
                            </button>
                          )}
                        </div>
                      </TabContainer>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <Footer
          homeImg={home}
          homeImgRef={workspace_base_url ? workspace_base_url : "/"}
          breadcrumbMainPage="Categories"
          breadcrumbSubPage="Category Detail"
          mainPageLink={workspace_base_url + "/categories"}
        />
      </div>
    </React.Fragment>
  );
};

export default CategoryDetail;
